// extracted by mini-css-extract-plugin
export default {"container":"amzHead&Text_container__ghRzU","headingContainer":"amzHead&Text_headingContainer__px9eG","headingText":"amzHead&Text_headingText__hLXJL"};